const rootReducer = (appReducers) => (state, action) =>
  appReducers(state, action);

export default rootReducer;
